import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: () => import('../views/home.vue'),
    children:[
      {
        path:'/',
        component:() => import('@/views/order.vue')
      },
      {
        path:'/account',
        component:() => import('@/views/account.vue')
      },
      {
        path:'/accountSettings',
        component:() => import('@/views/accountSettings.vue')
      },
      {
        path:'/custom',
        component:() => import('@/views/custom.vue')
      },
      {
        path:'/finance',
        component:() => import('@/views/finance.vue')
      },
      {
        path:'/juchengFinance',
        component:() => import('@/views/juchengFinance.vue')
      },
      {
        path:'/companyAdministration',
        component:() => import('@/views/companyAdministration.vue')
      },
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login.vue')
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/register.vue')
  },
]

const router = new VueRouter({
  routes
})

export default router
